import React from 'react';
import styled from 'styled-components';

const SkeletonContainer = styled.div`
  width: 100%;
  padding: 40px 20px;
`;

const SkeletonSectionTitle = styled.div`
  width: 250px;
  height: 36px;
  margin: 0 auto 30px;
  background: linear-gradient(90deg, #9cc54b 25%, #8ab03f 50%, #9cc54b 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 28px;
  }
`;

const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const SkeletonCard = styled.div`
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

const SkeletonImage = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

/**
 * PartnerSkeleton Component
 * Title centered at top + image-only cards (same size as product cards)
 * Responsive grid layout
 */
const PartnerSkeleton = ({cardCount = 4}) => {
	return (
		<SkeletonContainer>
			<SkeletonSectionTitle/>
			<SkeletonGrid>
				{[...Array(cardCount)].map((_, index) => (
					<SkeletonCard key={`partner-skeleton-${index}`}>
						<SkeletonImage/>
					</SkeletonCard>
				))}
			</SkeletonGrid>
		</SkeletonContainer>
	);
};

export default React.memo(PartnerSkeleton);
